import React from 'react';
import PropTypes from 'prop-types';

class ThirdPartyOfferCard extends React.Component {
    render() {
        const {
            offer,
            value,
            isDisabled,
            onToggle,
            cardRef,
            cardStyle,
            isInfoOpen,
            onInfoToggle,
        } = this.props;

        return (
            <div
                key={offer.code}
                className="third-party-offers__card"
                ref={cardRef}
                style={cardStyle}
            >
                <div className="third-party-offers__switch">
                    <button
                        type="button"
                        className={`third-party-offers__toggle ${value ? 'is-on' : 'is-off'}`}
                        disabled={isDisabled}
                        onClick={() => onToggle(offer.code, value)}
                        aria-pressed={value}
                        aria-label={`${offer.title} toggle`}
                    >
                        <span className="third-party-offers__toggle-thumb" />
                    </button>
                </div>
                <div className="third-party-offers__content">
                    <div className="third-party-offers__title-row">
                        <p>
                            <strong>{offer.title}</strong>
                            <span>{` - powered by ${offer.provider}`}</span>
                        </p>
                        {offer.infoTooltip ? (
                            <span className="third-party-offers__info">
                                <button
                                    type="button"
                                    className="third-party-offers__info-trigger"
                                    aria-label={`${offer.title} more information`}
                                    aria-expanded={isInfoOpen}
                                    onClick={() => onInfoToggle(!isInfoOpen)}
                                >
                                    <i className="spark-icon spark-icon-info-circle spark-icon--md" />
                                </button>

                                {isInfoOpen && (
                                    <div
                                        className="third-party-offers__popover"
                                        role="dialog"
                                        aria-label={offer.infoTooltip.title}
                                    >
                                        <div className="third-party-offers__popover-title-bar">
                                            <p className="third-party-offers__popover-title">
                                                {offer.infoTooltip.title}
                                            </p>
                                            <button
                                                type="button"
                                                className="third-party-offers__popover-close"
                                                aria-label="Close"
                                                onClick={() => onInfoToggle(false)}
                                            >
                                                <i className="spark-icon spark-icon-close" />
                                            </button>
                                        </div>
                                        {offer.infoTooltip.paragraphs.map((text, i) => (
                                            <p key={i} className="third-party-offers__popover-body">
                                                {text}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </span>
                        ) : (
                            <i className="spark-icon spark-icon-info-circle spark-icon--md" />
                        )}
                    </div>
                    <p className="third-party-offers__description">{offer.description}</p>
                    {offer.configuredText && (
                        <p className="third-party-offers__configured">{offer.configuredText}</p>
                    )}
                    {offer.detailsText && (
                        <p className="third-party-offers__details">{offer.detailsText}</p>
                    )}
                </div>
            </div>
        );
    }
}

ThirdPartyOfferCard.propTypes = {
    offer: PropTypes.shape({
        code: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        provider: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        infoTooltip: PropTypes.shape({
            title: PropTypes.string.isRequired,
            paragraphs: PropTypes.arrayOf(PropTypes.string).isRequired,
        }),
        configuredText: PropTypes.string,
        showEdit: PropTypes.bool,
        detailsText: PropTypes.string,
    }).isRequired,
    value: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    cardRef: PropTypes.func,
    cardStyle: PropTypes.object,
    isInfoOpen: PropTypes.bool,
    onInfoToggle: PropTypes.func,
};

ThirdPartyOfferCard.defaultProps = {
    isInfoOpen: false,
    onInfoToggle: () => {},
};

export default ThirdPartyOfferCard;


// WEBPACK FOOTER //
// ./src/components/widgets/ThirdPartyOfferCard.js